import React from 'react';
import Grid from '@mui/material/Grid';
import Link from 'next/link';
import { AppsAndSocials, ColoredBar, ScrollToTop } from '../@components';
import {
  ColumnLink,
  ColumnTitle,
  Copyrights,
  StyledGrid,
  Wrapper
} from './styled';
import { column1, column2, column3, column4 } from './primaryFooterLinks';

function FooterColumn({ column: { title, links } }) {
  return (
    <StyledGrid className="test" item xs={6} sm={6} md={3} lg={3}>
      <ColumnTitle>{title}</ColumnTitle>
      {links.map((item) => (
        <ColumnLink data-testid={title} key={item.name}>
          <Link href={item.link}>{item.name}</Link>
        </ColumnLink>
      ))}
    </StyledGrid>
  );
}

export default function PrimaryFooter(): JSX.Element {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Wrapper>
        <Grid container rowGap={5.5}>
          <Grid
            className="footer-links-container"
            item
            xs={12}
            sm={12}
            md={8}
            lg={9}
            order={{ xs: 2, md: 1 }}>
            <Grid container columns={40} rowGap={6}>
              <Grid
                item
                xs={4}
                sm={8}
                display={{ xs: 'inherit', md: 'none' }}
              />
              <Grid item xs={16} sm={8} md={10}>
                <FooterColumn column={column1} />
              </Grid>
              <Grid
                item
                xs={4}
                sm={11}
                display={{ xs: 'inherit', md: 'none' }}
              />
              <Grid item xs={16} sm={13} md={10}>
                <FooterColumn column={column2} />
              </Grid>
              <Grid
                item
                xs={4}
                sm={8}
                display={{ xs: 'inherit', md: 'none' }}
              />
              <Grid item xs={16} sm={8} md={10}>
                <FooterColumn column={column3} />
              </Grid>
              <Grid
                item
                xs={4}
                sm={11}
                display={{ xs: 'inherit', md: 'none' }}
              />
              <Grid item xs={16} sm={13} md={10}>
                <FooterColumn column={column4} />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            className="app-and-social-container"
            item
            xs={12}
            sm={12}
            md={4}
            lg={3}
            order={{ xs: 1, md: 2 }}>
            <AppsAndSocials />
          </Grid>
        </Grid>

        <Grid
          container
          alignContent="center"
          alignItems="stretch"
          justifyContent="center">
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            textAlign={{ xs: 'center', md: 'left', lg: 'left', xl: 'left' }}>
            <Copyrights>
              {currentYear} Ingenio, LLC. © All rights reserved.
            </Copyrights>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            textAlign={{ xs: 'center', md: 'right', lg: 'right', xl: 'right' }}
            mt={2}>
            <ScrollToTop />
          </Grid>
        </Grid>
      </Wrapper>
      <ColoredBar />
    </>
  );
}
